import { Badge } from 'cpool-components/general/Badge';

import { cn } from '~/utils/cnTailwind';

interface IconBadgeProps {
    icon: React.ReactNode;
    className?: string;
}

export const IconBadge: React.FC<IconBadgeProps> = ({ className, icon }) => {
    return (
        <Badge
            className={cn(
                'flex items-center justify-center rounded-md text-[20px] border-none h-10 aspect-square',
                className,
            )}
        >
            {icon}
        </Badge>
    );
};
